import SvgIcon from "@mui/material/SvgIcon";

export default function ChatIcon(props: any) {
  return (
    <SvgIcon {...props} viewBox="0 0 32 32">
      <path d="m29.87 14.45-3.61-2.58H14.8v-8.4h15.07ZM7.03 23.2l-4.9 4.35V11.47H13.2v2h11.33v9.73ZM31.47 1.87H13.2v8H.53V31.1l7.1-6.31h18.5V13.74l5.34 3.81V1.87" />
    </SvgIcon>
  );
}
